<template>
	<transition
			appear
			:appear-active-class="$_rctSchdlShtLyt_stylePageLayoutAnimation()">
		<v-row class="customVRow" no-gutters>
			<v-col>
				<template v-if="$_rctSchdlShtLyt_langRecruitTitle">
					<v-row justify="center">
						<v-col cols="11" md="9">
							<v-sheet
									class="customVSheet pa-3"
									:color="$_rctSchdlShtLyt_styleScheduleSheetHeaderSheetColor"
									:dark="$_rctSchdlShtLyt_styleScheduleSheetHeaderSheetDark"
									:elevation="$_rctSchdlShtLyt_styleScheduleSheetHeaderSheetElevation"
									:light="$_rctSchdlShtLyt_styleScheduleSheetHeaderSheetLight">
								<v-card color="transparent" flat>
									<v-card-text class="center">
										<center>
											<span	class="headline"
													v-html="$_rctSchdlShtLyt_langRecruitTitle" />
										</center>
									</v-card-text>
								</v-card>
							</v-sheet>
						</v-col>
					</v-row>
				</template>
				<template v-if="isObject($_rctSchdlShtLyt_styleRecruitBigImage) || isObject($_rctSchdlShtLyt_styleRecruitImage) || $_rctSchdlShtLyt_langRecruitSubTitle || $_rctSchdlShtLyt_langRecruitText">
					<v-row justify="center">
						<v-col cols="11" md="9">
							<v-sheet
									class="customVSheet"
									:color="$_rctSchdlShtLyt_styleScheduleSheetBodySheetColor"
									:dark="$_rctSchdlShtLyt_styleScheduleSheetBodySheetDark"
									:elevation="$_rctSchdlShtLyt_styleScheduleSheetBodySheetElevation"
									:light="$_rctSchdlShtLyt_styleScheduleSheetBodySheetLight">
								<v-card	class="customVCard"
										color="transparent"
										flat>
									<template v-if="isObject($_rctSchdlShtLyt_styleRecruitBigImage)">
										<v-row>
											<v-col>
												<v-img	class="customVImg"
														:src="$_rctSchdlShtLyt_styleRecruitBigImageUrl" />
											</v-col>
										</v-row>
									</template>
									<v-row>
										<template v-if="isObject($_rctSchdlShtLyt_styleRecruitImage)">
											<v-col cols="12" md="4" class="center">
												<v-img	class="customVImg"
														:src="$_rctSchdlShtLyt_styleRecruitImageUrl" />
											</v-col>
										</template>
										<v-col>
											<template v-if="$_rctSchdlShtLyt_langRecruitSubTitle">
												<v-card-title>
													<span	class="title"
															v-html="$_rctSchdlShtLyt_langRecruitSubTitle" />
												</v-card-title>
											</template>
											<template v-if="$_rctSchdlShtLyt_langRecruitText">
												<v-card-text>
													<span v-html="$_rctSchdlShtLyt_langRecruitText" />
												</v-card-text>
											</template>
										</v-col>
									</v-row>
								</v-card>
							</v-sheet>
						</v-col>
					</v-row>
				</template>
				<v-row justify="center">
					<v-col cols="11" md="9">
						<v-sheet 
								class="customVSheet"
								:color="$_rctSchdlShtLyt_styleScheduleSheetBodySheetColor"
								:dark="$_rctSchdlShtLyt_styleScheduleSheetBodySheetDark"
								:elevation="$_rctSchdlShtLyt_styleScheduleSheetBodySheetElevation"
								:light="$_rctSchdlShtLyt_styleScheduleSheetBodySheetLight">
							<v-card	class="customVCard"
									color="transparent"
									flat>
								<v-card-text>
									<v-row no-gutters align="center">
										<v-col cols="auto">
											Applied Date
										</v-col>
										<v-col class="pl-3">
											<v-menu	v-model="showCalendar_"
													
													offset-y

													max-width="290px"
													min-width="290px"

													:close-on-content-click="false">
												<template v-slot:activator="{ on }">
													<v-text-field
															class="customVTextField"

															v-model="$store.state.page.calendar.date"

															single-line

															:background-color="$_rctSchdlShtLyt_styleScheduleSheetTextFieldBackgroundColor"
															:clearable="$_rctSchdlShtLyt_styleScheduleSheetTextFieldClearable"
															:color="$_rctSchdlShtLyt_styleScheduleSheetTextFieldColor"
															:counter="$_rctSchdlShtLyt_styleScheduleSheetTextFieldCounter"
															:dark="$_rctSchdlShtLyt_styleScheduleSheetTextFieldDark"
															:filled="$_rctSchdlShtLyt_styleScheduleSheetTextFieldFilled"
															:flat="$_rctSchdlShtLyt_styleScheduleSheetTextFieldFlat"
															:light="$_rctSchdlShtLyt_styleScheduleSheetTextFieldLight"
															:outlined="$_rctSchdlShtLyt_styleScheduleSheetTextFieldOutlined"
															:solo="$_rctSchdlShtLyt_styleScheduleSheetTextFieldSolo"
															:solo-inverted="$_rctSchdlShtLyt_styleScheduleSheetTextFieldSoloInverted"

															:append-icon="$_rctSchdlShtLyt_styleScheduleSheetTextFieldAppendIcon"
															:append-outer-icon="$_rctSchdlShtLyt_styleScheduleSheetTextFieldAppendOuterIcon"
															:prepend-icon="$_rctSchdlShtLyt_styleScheduleSheetTextFieldPrependIcon"
															:prepend-inner-icon="$_rctSchdlShtLyt_styleScheduleSheetTextFieldPrependInnerIcon"

															v-on="on" />
												</template>
												<v-date-picker
														v-model="$store.state.page.calendar.date"
														@change="showCalendar_ = false" />
											</v-menu>
										</v-col>
									</v-row>
								</v-card-text>
							</v-card>
						</v-sheet>
					</v-col>
				</v-row>
				<template v-for="(scheduleVals, scheduleKey) in sortObject($_rctSchdlShtLyt_recruitSchedules, 'order')">
					<template v-if="$_rctSchdlShtLyt_checkAppliedDate(scheduleVals)">
						<v-row	:key="scheduleKey"
								no-gutters>
							<v-col>
								<template v-if="scheduleVals.title">
									<v-row justify="center">
										<v-col cols="11" md="9">
											<v-sheet
													class="customVSheet pa-3"
													:color="$_rctSchdlShtLyt_styleScheduleSheetHeaderSheetColor"
													:dark="$_rctSchdlShtLyt_styleScheduleSheetHeaderSheetDark"
													:elevation="$_rctSchdlShtLyt_styleScheduleSheetHeaderSheetElevation"
													:light="$_rctSchdlShtLyt_styleScheduleSheetHeaderSheetLight">
												<v-card	class="customVCard"
														color="transparent"
														flat>
													<v-card-text class="center">
														<center>
															<span	class="headline"
																	v-html="$_rctSchdlShtLyt_langContentTitle(scheduleVals)" />
														</center>
													</v-card-text>
												</v-card>
											</v-sheet>
										</v-col>
									</v-row>
								</template>
								<v-row justify="center">
									<v-col cols="11" md="9">
										<v-sheet
												class="customVSheet"
												:color="$_rctSchdlShtLyt_styleScheduleSheetBodySheetColor"
												:dark="$_rctSchdlShtLyt_styleScheduleSheetBodySheetDark"
												:elevation="$_rctSchdlShtLyt_styleScheduleSheetBodySheetElevation"
												:light="$_rctSchdlShtLyt_styleScheduleSheetBodySheetLight">
											<v-card	class="customVCard"
													color="transparent"
													flat>
												<template v-if="isObject(scheduleVals.bigImage)">
													<v-row>
														<v-col>
															<v-img	class="customVImg"
																	:src="$_rctSchdlShtLyt_styleContentBigImageUrl(scheduleVals)" />
														</v-col>
													</v-row>
												</template>
												<template v-if="isObject(scheduleVals.video)">
													<v-row>
														<v-col>
															<card-video
																	:contentKey="scheduleKey"
																	:contents="contents"
																	:inits="inits" />
														</v-col>
													</v-row>
												</template>
												<template v-if="isObject(scheduleVals.bigChart)">
													<v-row>
														<v-col>
															<card-big-chart
																	:contentKey="scheduleKey"
																	:contents="contents"
																	:inits="inits" />
														</v-col>
													</v-row>
												</template>
												<v-row>
													<template v-if="isObject(scheduleVals.image)">
														<v-col cols="12" md="4" class="center">
															<v-img	class="customVImg"
																	:src="$_rctSchdlShtLyt_styleContentImageUrl(scheduleVals)" />
														</v-col>
													</template>
													<v-col>
														<template v-if="scheduleVals.subTitle">
															<v-card-title>
																<v-row>
																	<v-col cols="auto">
																		<span	class="title"
																				v-html="$_rctSchdlShtLyt_langContentSubTitle(scheduleVals)" />
																	</v-col>
																	<v-spacer />
																	<v-col cols="auto">
																		<span	class="caption"
																				v-text="$_rctSchdlShtLyt_langContentStartDate(scheduleVals)" />
																	</v-col>
																	<v-col cols="auto">-</v-col>
																	<v-col cols="auto">
																		<span	class="caption"
																				v-text="$_rctSchdlShtLyt_langContentEndDate(scheduleVals)" />
																	</v-col>
																</v-row>
															</v-card-title>
														</template>
														<template v-if="!isFalse($_rctSchdlShtLyt_langContentText(contentVals))">
															<v-card-text>
																<span v-html="$_rctSchdlShtLyt_langContentText(scheduleVals)" />
															</v-card-text>
														</template>
														<template v-if="isObject(scheduleVals.actionButtons)">
															<v-card-actions>
																<v-row dense>
																	<template v-for="(actionButtonVals, actionButtonKey) in sortObject(scheduleVals.actionButtons, 'order')">
																		<v-col :key="actionButtonKey">
																			<v-btn	class="customVBtn"
																					:block="$_rctSchdlShtLyt_styleScheduleSheetActionButtonBlock"
																					:color="$_rctSchdlShtLyt_styleScheduleSheetActionButtonColor"
																					:dark="$_rctSchdlShtLyt_styleScheduleSheetActionButtonDark"
																					:depressed="$_rctSchdlShtLyt_styleScheduleSheetActionButtonDepressed"
																					:elevation="$_rctSchdlShtLyt_styleScheduleSheetActionButtonElevation"
																					:large="$_rctSchdlShtLyt_styleScheduleSheetActionButtonLarge"
																					:light="$_rctSchdlShtLyt_styleScheduleSheetActionButtonLight"
																					:outlined="$_rctSchdlShtLyt_styleScheduleSheetActionButtonOutlined"
																					:rounded="$_rctSchdlShtLyt_styleScheduleSheetActionButtonRounded"
																					:small="$_rctSchdlShtLyt_styleScheduleSheetActionButtonSmall"
																					:text="$_rctSchdlShtLyt_styleScheduleSheetActionButtonFlat"
																					@click="openLink(actionButtonVals.link)"
																					v-text="$_rctSchdlShtLyt_langActionButtonTitle(actionButtonVals)" />
																		</v-col>
																	</template>
																</v-row>
															</v-card-actions>
														</template>
														<v-card-actions>
															<v-row dense>
																<v-col cols="auto">
																	<v-btn	class="customVBtn"
																			:block="$_rctSchdlShtLyt_styleScheduleSheetOpenScheduleButtonBlock"
																			:color="$_rctSchdlShtLyt_styleScheduleSheetOpenScheduleButtonColor"
																			:dark="$_rctSchdlShtLyt_checkScheduleIsApplied(scheduleKey) ? $_rctSchdlShtLyt_styleScheduleSheetOpenScheduleButtonDark : $_rctSchdlShtLyt_stateAppIsDarkTheme"
																			:depressed="$_rctSchdlShtLyt_styleScheduleSheetOpenScheduleButtonDepressed"
																			:elevation="$_rctSchdlShtLyt_styleScheduleSheetOpenScheduleButtonElevation"
																			:large="$_rctSchdlShtLyt_styleScheduleSheetOpenScheduleButtonLarge"
																			:light="$_rctSchdlShtLyt_styleScheduleSheetOpenScheduleButtonLight"
																			:outlined="$_rctSchdlShtLyt_styleScheduleSheetOpenScheduleButtonOutlined"
																			:rounded="$_rctSchdlShtLyt_styleScheduleSheetOpenScheduleButtonRounded"
																			:small="$_rctSchdlShtLyt_styleScheduleSheetOpenScheduleButtonSmall"
																			:text="$_rctSchdlShtLyt_styleScheduleSheetOpenScheduleButtonFlat"
																			
																			:disabled="!$_rctSchdlShtLyt_checkScheduleIsApplied(scheduleKey)"

																			@click="$_rctSchdlShtLyt_openSchedule(scheduleKey)"
																			v-text="$_rctSchdlShtLyt_langScheduleSheetOpenSchedule" />
																</v-col>
															</v-row>
														</v-card-actions>
													</v-col>
												</v-row>
											</v-card>
										</v-sheet>
									</v-col>
								</v-row>
							</v-col>
						</v-row>
					</template>
				</template>
			</v-col>
		</v-row>
	</transition>
</template>

<script>
	export default {
		name: 'RecruitScheduleSheetLayout',
		props: {
			recruitment: Object,
			
			contents: Object,
			inits: Object
		},
		data() {
			return {
				showCalendar_: false,
				appliedDate_: null
			}
		},
		computed: {
			// params
			$_rctSchdlShtLyt_params() {
				const self_ = this;
				const route_ = self_.$route
				return route_.params
			},
			$_rctSchdlShtLyt_paramsRecruitmentId() {
				const self_ = this;
				const params_ = self_.$_rctSchdlShtLyt_params;
				if(self_.isFalse(params_)) { return null }
				return params_.recruitmentId
			},
			// recruit
			$_rctSchdlShtLyt_recruitRecruitment() {
				const self_ = this;
				return self_.recruitment[self_.$_rctSchdlShtLyt_paramsRecruitmentId]
			},
			$_rctSchdlShtLyt_recruitRecruitmentIsGroupRecruitment() {
				const self_ = this;
				const recruitment_ = self_.$_rctSchdlShtLyt_recruitRecruitment;
				if(self_.isEmpty(recruitment_)) { return null }
				return recruitment_.isGroupRecruitment
			},
			$_rctSchdlShtLyt_recruitRecruitmentIsSequentialRecruitment() {
				const self_ = this;
				const recruitment_ = self_.$_rctSchdlShtLyt_recruitRecruitment;
				if(self_.isEmpty(recruitment_)) { return null }
				return recruitment_.isSequentialRecruitment
			},
			$_rctSchdlShtLyt_recruitSchedules() {
				const self_ = this;
				const recruitment_ = self_.$_rctSchdlShtLyt_recruitRecruitment;
				if(self_.isEmpty(recruitment_)) { return null }
				return recruitment_.schedules
			},
			// state
			$_rctSchdlShtLyt_stateAppIsDarkTheme() {
				const self_ = this;
				return self_.getAppState('isDarkTheme')
			},
			// (recruit)
			$_rctSchdlShtLyt_stateUserRecruit() {
				const self_ = this;
				const recruit_ = self_.getUserState('recruit')
				return recruit_[self_.$_rctSchdlShtLyt_paramsRecruitmentId]
			},
			$_rctSchdlShtLyt_stateUserRecruitAppliedSchedule() {
				const self_ = this;
				const recruit_ = self_.$_rctSchdlShtLyt_stateUserRecruit;
				if(self_.isEmpty(recruit_)) { return null }
				return recruit_.appliedSchedule
			},
			// lang
			$_rctSchdlShtLyt_langScheduleSheetOpenSchedule() {
				const self_ = this;
				const lang_ = self_.getInitsLangVal(self_.inits, 'scheduleSheetOpenSchedule')
				return self_.getLangsVal(lang_)
			},
			$_rctSchdlShtLyt_langScheduleSheetInputDate() {
				const self_ = this;
				const lang_ = self_.getInitsLangVal(self_.inits, 'scheduleSheetInputDate')
				return self_.getLangsVal(lang_)
			},
			// (content)
			$_rctSchdlShtLyt_langContentTitle() {
				const self_ = this;
				return contentVals => {
					const title_ = contentVals.title;
					if(self_.isFalse(title_)) { return null }
					return self_.getLangsVal(title_)
				}
			},
			$_rctSchdlShtLyt_langContentSubTitle() {
				const self_ = this;
				return contentVals => {
					const subTitle_ = contentVals.subTitle;
					if(self_.isFalse(subTitle_)) { return null }
					return self_.getLangsVal(subTitle_)
				}
			},
			$_rctSchdlShtLyt_langContentText() {
				const self_ = this;
				return contentVals => {
					const text_ = contentVals.text;
					if(self_.isFalse(text_)) { return null }
					return self_.getLangsVal(text_)
				}
			},
			$_rctSchdlShtLyt_langContentStartDate() {
				const self_ = this;
				return contentVals => {
					const date_ = contentVals.startDate;
					if(self_.isFalse(date_)) { return null }
					return self_.formatTimestamp(date_, 'YYYY-MM-DD')
				}
			},
			$_rctSchdlShtLyt_langContentEndDate() {
				const self_ = this;
				return contentVals => {
					const date_ = contentVals.endDate;
					if(self_.isFalse(date_)) { return null }
					return self_.formatTimestamp(date_, 'YYYY-MM-DD')
				}
			},
			// (action buttons)
			$_rctSchdlShtLyt_langActionButtonTitle() {
				const self_ = this;
				return actionButtonVals => {
					if(self_.isFalse(actionButtonVals.title)) { return null }
					return self_.getLangsVal(actionButtonVals.title)
				}
			},
			// (recruit)
			$_rctSchdlShtLyt_langRecruitTitle() {
				const self_ = this;
				const recruit_ = self_.$_rctSchdlShtLyt_recruitRecruitment;
				if(self_.isEmpty(recruit_)) { return null }
				return self_.getLangsVal(recruit_.title)
			},
			$_rctSchdlShtLyt_langRecruitSubTitle() {
				const self_ = this;
				const recruit_ = self_.$_rctSchdlShtLyt_recruitRecruitment;
				if(self_.isEmpty(recruit_)) { return null }
				return self_.getLangsVal(recruit_.subTitle)
			},
			$_rctSchdlShtLyt_langRecruitText() {
				const self_ = this;
				const recruit_ = self_.$_rctSchdlShtLyt_recruitRecruitment;
				if(self_.isEmpty(recruit_)) { return null }
				return self_.getLangsVal(recruit_.text)
			},
			// style
			$_rctSchdlShtLyt_stylePageLayout() {
				const self_ = this;
				return () => {
					if(self_.isEmpty(self_.inits)) { return null }
					return self_.getInitsStyleVal(self_.inits, 'pageLayout')
				}
			},
			$_rctSchdlShtLyt_stylePageLayoutAnimation() {
				const self_ = this;
				return () => {
					const layout_ = self_.$_rctSchdlShtLyt_stylePageLayout()
					if(self_.isFalse(layout_)) { return null }
					return self_.getStylesVal(layout_.animation)
				}
			},
			$_rctSchdlShtLyt_styleScheduleSheetHeaderSheet() {
				const self_ = this;
				return self_.getInitsStyleVal(self_.inits, 'scheduleSheetHeaderSheet')
			},
			$_rctSchdlShtLyt_styleScheduleSheetHeaderSheetColor() {
				const self_ = this;
				const sheet_ = self_.$_rctSchdlShtLyt_styleScheduleSheetHeaderSheet;
				if(self_.isFalse(sheet_)) { return null }
				return self_.getStylesVal(sheet_.color)
			},
			$_rctSchdlShtLyt_styleScheduleSheetHeaderSheetDark() {
				const self_ = this;
				const sheet_ = self_.$_rctSchdlShtLyt_styleScheduleSheetHeaderSheet;
				if(self_.isFalse(sheet_)) { return null }
				return self_.getStylesVal(sheet_.dark)
			},
			$_rctSchdlShtLyt_styleScheduleSheetHeaderSheetElevation() {
				const self_ = this;
				const sheet_ = self_.$_rctSchdlShtLyt_styleScheduleSheetHeaderSheet;
				if(self_.isFalse(sheet_)) { return null }
				return self_.getStylesVal(sheet_.elevation)
			},
			$_rctSchdlShtLyt_styleScheduleSheetHeaderSheetLight() {
				const self_ = this;
				const sheet_ = self_.$_rctSchdlShtLyt_styleScheduleSheetHeaderSheet;
				if(self_.isFalse(sheet_)) { return null }
				return self_.getStylesVal(sheet_.light)
			},
			$_rctSchdlShtLyt_styleScheduleSheetBodySheet() {
				const self_ = this;
				return self_.getInitsStyleVal(self_.inits, 'scheduleSheetBodySheet')
			},
			$_rctSchdlShtLyt_styleScheduleSheetBodySheetColor() {
				const self_ = this;
				const sheet_ = self_.$_rctSchdlShtLyt_styleScheduleSheetBodySheet;
				if(self_.isFalse(sheet_)) { return null }
				return self_.getStylesVal(sheet_.color)
			},
			$_rctSchdlShtLyt_styleScheduleSheetBodySheetDark() {
				const self_ = this;
				const sheet_ = self_.$_rctSchdlShtLyt_styleScheduleSheetBodySheet;
				if(self_.isFalse(sheet_)) { return null }
				return self_.getStylesVal(sheet_.dark)
			},
			$_rctSchdlShtLyt_styleScheduleSheetBodySheetElevation() {
				const self_ = this;
				const sheet_ = self_.$_rctSchdlShtLyt_styleScheduleSheetBodySheet;
				if(self_.isFalse(sheet_)) { return null }
				return self_.getStylesVal(sheet_.elevation)
			},
			$_rctSchdlShtLyt_styleScheduleSheetBodySheetLight() {
				const self_ = this;
				const sheet_ = self_.$_rctSchdlShtLyt_styleScheduleSheetBodySheet;
				if(self_.isFalse(sheet_)) { return null }
				return self_.getStylesVal(sheet_.light)
			},
			$_rctSchdlShtLyt_styleScheduleSheetTextField() {
				const self_ = this;
				if(self_.isEmpty(self_.inits)) { return null }
				return self_.getInitsStyleVal(self_.inits, 'scheduleSheetTextField')
			},
			$_rctSchdlShtLyt_styleScheduleSheetTextFieldAppendIcon() {
				const self_ = this;
				const style_ = self_.$_rctSchdlShtLyt_styleScheduleSheetTextField;
				if(self_.isFalse(style_)) { return null }
				return self_.getStylesVal(style_.appendIcon)
			},
			$_rctSchdlShtLyt_styleScheduleSheetTextFieldAppendOuterIcon() {
				const self_ = this;
				const style_ = self_.$_rctSchdlShtLyt_styleScheduleSheetTextField;
				if(self_.isFalse(style_)) { return null }
				return self_.getStylesVal(style_.appendOuterIcon)
			},
			$_rctSchdlShtLyt_styleScheduleSheetTextFieldBackgroundColor() {
				const self_ = this;
				const style_ = self_.$_rctSchdlShtLyt_styleScheduleSheetTextField
				if(self_.isFalse(style_)) { return null }
				return self_.getStylesVal(style_.backgroundColor)
			},
			$_rctSchdlShtLyt_styleScheduleSheetTextFieldClearable() {
				const self_ = this;
				const style_ = self_.$_rctSchdlShtLyt_styleScheduleSheetTextField
				if(self_.isFalse(style_)) { return null }
				return self_.getStylesVal(style_.clearable)
			},
			$_rctSchdlShtLyt_styleScheduleSheetTextFieldColor() {
				const self_ = this;
				const style_ = self_.$_rctSchdlShtLyt_styleScheduleSheetTextField
				if(self_.isFalse(style_)) { return null }
				return self_.getStylesVal(style_.color)
			},
			$_rctSchdlShtLyt_styleScheduleSheetTextFieldCounter() {
				const self_ = this;
				const style_ = self_.$_rctSchdlShtLyt_styleScheduleSheetTextField
				if(self_.isFalse(style_)) { return null }
				return self_.getStylesVal(style_.counter)
			},
			$_rctSchdlShtLyt_styleScheduleSheetTextFieldDark() {
				const self_ = this;
				const style_ = self_.$_rctSchdlShtLyt_styleScheduleSheetTextField
				if(self_.isFalse(style_)) { return null }
				return self_.getStylesVal(style_.dark)
			},
			$_rctSchdlShtLyt_styleScheduleSheetTextFieldFilled() {
				const self_ = this;
				const style_ = self_.$_rctSchdlShtLyt_styleScheduleSheetTextField
				if(self_.isFalse(style_)) { return null }
				return self_.getStylesVal(style_.filled)
			},
			$_rctSchdlShtLyt_styleScheduleSheetTextFieldFlat() {
				const self_ = this;
				const style_ = self_.$_rctSchdlShtLyt_styleScheduleSheetTextField
				if(self_.isFalse(style_)) { return null }
				return self_.getStylesVal(style_.flat)
			},
			$_rctSchdlShtLyt_styleScheduleSheetTextFieldLight() {
				const self_ = this;
				const style_ = self_.$_rctSchdlShtLyt_styleScheduleSheetTextField
				if(self_.isFalse(style_)) { return null }
				return self_.getStylesVal(style_.light)
			},
			$_rctSchdlShtLyt_styleScheduleSheetTextFieldOutlined() {
				const self_ = this;
				const style_ = self_.$_rctSchdlShtLyt_styleScheduleSheetTextField
				if(self_.isFalse(style_)) { return null }
				return self_.getStylesVal(style_.outlined)
			},
			$_rctSchdlShtLyt_styleScheduleSheetTextFieldPrependIcon() {
				const self_ = this;
				const style_ = self_.$_rctSchdlShtLyt_styleScheduleSheetTextField;
				if(self_.isFalse(style_)) { return null }
				return self_.getStylesVal(style_.prependIcon)
			},
			$_rctSchdlShtLyt_styleScheduleSheetTextFieldPrependInnerIcon() {
				const self_ = this;
				const style_ = self_.$_rctSchdlShtLyt_styleScheduleSheetTextField;
				if(self_.isFalse(style_)) { return null }
				return self_.getStylesVal(style_.prependInnerIcon)
			},
			$_rctSchdlShtLyt_styleScheduleSheetTextFieldSolo() {
				const self_ = this;
				const style_ = self_.$_rctSchdlShtLyt_styleScheduleSheetTextField
				if(self_.isFalse(style_)) { return null }
				return self_.getStylesVal(style_.solo)
			},
			$_rctSchdlShtLyt_styleScheduleSheetTextFieldSoloInverted() {
				const self_ = this;
				const style_ = self_.$_rctSchdlShtLyt_styleScheduleSheetTextField
				if(self_.isFalse(style_)) { return null }
				return self_.getStylesVal(style_.soloInverted)
			},
			$_rctSchdlShtLyt_styleScheduleSheetActionButton() {
				const self_ = this;
				return self_.getInitsStyleVal(self_.inits, 'scheduleSheetActionButton')
			},
			$_rctSchdlShtLyt_styleScheduleSheetActionButtonBlock() {
				const self_ = this;
				const actionButton_ = self_.$_rctSchdlShtLyt_styleScheduleSheetActionButton;
				if(self_.isFalse(actionButton_)) { return null }
				return self_.getStylesVal(actionButton_.block)
			},
			$_rctSchdlShtLyt_styleScheduleSheetActionButtonColor() {
				const self_ = this;
				const actionButton_ =self_.$_rctSchdlShtLyt_styleScheduleSheetActionButton;
				if(self_.isFalse(actionButton_)) { return null }
				return self_.getStylesVal(actionButton_.color)
			},
			$_rctSchdlShtLyt_styleScheduleSheetActionButtonDark() {
				const self_ = this;
				const actionButton_ = self_.$_rctSchdlShtLyt_styleScheduleSheetActionButton;
				if(self_.isFalse(actionButton_)) { return null }
				return self_.getStylesVal(actionButton_.dark)
			},
			$_rctSchdlShtLyt_styleScheduleSheetActionButtonDepressed() {
				const self_ = this;
				const actionButton_ = self_.$_rctSchdlShtLyt_styleScheduleSheetActionButton;
				if(self_.isFalse(actionButton_)) { return null }
				return self_.getStylesVal(actionButton_.depressed)
			},
			$_rctSchdlShtLyt_styleScheduleSheetActionButtonElevation() {
				const self_ = this;
				const actionButton_ = self_.$_rctSchdlShtLyt_styleScheduleSheetActionButton;
				if(self_.isFalse(actionButton_)) { return null }
				return self_.getStylesVal(actionButton_.elevation)
			},
			$_rctSchdlShtLyt_styleScheduleSheetActionButtonFlat() {
				const self_ = this;
				const actionButton_ = self_.$_rctSchdlShtLyt_styleScheduleSheetActionButton;
				if(self_.isFalse(actionButton_)) { return null }
				return self_.getStylesVal(actionButton_.flat)
			},
			$_rctSchdlShtLyt_styleScheduleSheetActionButtonLarge() {
				const self_ = this;
				const actionButton_ = self_.$_rctSchdlShtLyt_styleScheduleSheetActionButton;
				if(self_.isFalse(actionButton_)) { return null }
				return self_.getStylesVal(actionButton_.large)
			},
			$_rctSchdlShtLyt_styleScheduleSheetActionButtonLight() {
				const self_ = this;
				const actionButton_ = self_.$_rctSchdlShtLyt_styleScheduleSheetActionButton;
				if(self_.isFalse(actionButton_)) { return null }
				return self_.getStylesVal(actionButton_.light)
			},
			$_rctSchdlShtLyt_styleScheduleSheetActionButtonOutlined() {
				const self_ = this;
				const actionButton_ = self_.$_rctSchdlShtLyt_styleScheduleSheetActionButton;
				if(self_.isFalse(actionButton_)) { return null }
				return self_.getStylesVal(actionButton_.outlined)
			},
			$_rctSchdlShtLyt_styleScheduleSheetActionButtonRounded() {
				const self_ = this;
				const actionButton_ = self_.$_rctSchdlShtLyt_styleScheduleSheetActionButton;
				if(self_.isFalse(actionButton_)) { return null }
				return self_.getStylesVal(actionButton_.rounded)
			},
			$_rctSchdlShtLyt_styleScheduleSheetActionButtonSmall() {
				const self_ = this;
				const actionButton_ = self_.$_rctSchdlShtLyt_styleScheduleSheetActionButton;
				if(self_.isFalse(actionButton_)) { return null }
				return self_.getStylesVal(actionButton_.small)
			},
			$_rctSchdlShtLyt_styleScheduleSheetOpenScheduleButton() {
				const self_ = this;
				return self_.getInitsStyleVal(self_.inits, 'scheduleSheetOpenScheduleButton')
			},
			$_rctSchdlShtLyt_styleScheduleSheetOpenScheduleButtonBlock() {
				const self_ = this;
				const actionButton_ = self_.$_rctSchdlShtLyt_styleScheduleSheetOpenScheduleButton;
				if(self_.isFalse(actionButton_)) { return null }
				return self_.getStylesVal(actionButton_.block)
			},
			$_rctSchdlShtLyt_styleScheduleSheetOpenScheduleButtonColor() {
				const self_ = this;
				const actionButton_ =self_.$_rctSchdlShtLyt_styleScheduleSheetOpenScheduleButton;
				if(self_.isFalse(actionButton_)) { return null }
				return self_.getStylesVal(actionButton_.color)
			},
			$_rctSchdlShtLyt_styleScheduleSheetOpenScheduleButtonDark() {
				const self_ = this;
				const actionButton_ = self_.$_rctSchdlShtLyt_styleScheduleSheetOpenScheduleButton;
				if(self_.isFalse(actionButton_)) { return null }
				return self_.getStylesVal(actionButton_.dark)
			},
			$_rctSchdlShtLyt_styleScheduleSheetOpenScheduleButtonDepressed() {
				const self_ = this;
				const actionButton_ = self_.$_rctSchdlShtLyt_styleScheduleSheetOpenScheduleButton;
				if(self_.isFalse(actionButton_)) { return null }
				return self_.getStylesVal(actionButton_.depressed)
			},
			$_rctSchdlShtLyt_styleScheduleSheetOpenScheduleButtonElevation() {
				const self_ = this;
				const actionButton_ = self_.$_rctSchdlShtLyt_styleScheduleSheetOpenScheduleButton;
				if(self_.isFalse(actionButton_)) { return null }
				return self_.getStylesVal(actionButton_.elevation)
			},
			$_rctSchdlShtLyt_styleScheduleSheetOpenScheduleButtonFlat() {
				const self_ = this;
				const actionButton_ = self_.$_rctSchdlShtLyt_styleScheduleSheetOpenScheduleButton;
				if(self_.isFalse(actionButton_)) { return null }
				return self_.getStylesVal(actionButton_.flat)
			},
			$_rctSchdlShtLyt_styleScheduleSheetOpenScheduleButtonLarge() {
				const self_ = this;
				const actionButton_ = self_.$_rctSchdlShtLyt_styleScheduleSheetOpenScheduleButton;
				if(self_.isFalse(actionButton_)) { return null }
				return self_.getStylesVal(actionButton_.large)
			},
			$_rctSchdlShtLyt_styleScheduleSheetOpenScheduleButtonLight() {
				const self_ = this;
				const actionButton_ = self_.$_rctSchdlShtLyt_styleScheduleSheetOpenScheduleButton;
				if(self_.isFalse(actionButton_)) { return null }
				return self_.getStylesVal(actionButton_.light)
			},
			$_rctSchdlShtLyt_styleScheduleSheetOpenScheduleButtonOutlined() {
				const self_ = this;
				const actionButton_ = self_.$_rctSchdlShtLyt_styleScheduleSheetOpenScheduleButton;
				if(self_.isFalse(actionButton_)) { return null }
				return self_.getStylesVal(actionButton_.outlined)
			},
			$_rctSchdlShtLyt_styleScheduleSheetOpenScheduleButtonRounded() {
				const self_ = this;
				const actionButton_ = self_.$_rctSchdlShtLyt_styleScheduleSheetOpenScheduleButton;
				if(self_.isFalse(actionButton_)) { return null }
				return self_.getStylesVal(actionButton_.rounded)
			},
			$_rctSchdlShtLyt_styleScheduleSheetOpenScheduleButtonSmall() {
				const self_ = this;
				const actionButton_ = self_.$_rctSchdlShtLyt_styleScheduleSheetOpenScheduleButton;
				if(self_.isFalse(actionButton_)) { return null }
				return self_.getStylesVal(actionButton_.small)
			},
			// (content)
			$_rctSchdlShtLyt_styleContentImage() {
				return contentVals => {
					return contentVals.image
				}
			},
			$_rctSchdlShtLyt_styleContentImageUrl() {
				const self_ = this;
				return contentVals => {
					const image_ = self_.$_rctSchdlShtLyt_styleContentImage(contentVals)
					if(self_.isEmpty(image_)) { return null }
					return self_.getStylesVal(image_.url)
				}
			},
			$_rctSchdlShtLyt_styleContentBigImage() {
				return contentVals => {
					return contentVals.bigImage
				}
			},
			$_rctSchdlShtLyt_styleContentBigImageUrl() {
				const self_ = this;
				return contentVals => {
					const bigImage_ = self_.$_rctSchdlShtLyt_styleContentBigImage(contentVals)
					if(self_.isEmpty(bigImage_)) { return null }
					return self_.getStylesVal(bigImage_.url)
				}
			},
			// (recruit)
			$_rctSchdlShtLyt_styleRecruitImage() {
				const self_ = this;
				const recruit_ = self_.$_rctSchdlShtLyt_recruitRecruitment;
				if(self_.isEmpty(recruit_)) { return null }
				return recruit_.image
			},
			$_rctSchdlShtLyt_styleRecruitImageUrl() {
				const self_ = this;
				const image_ = self_.$_rctSchdlShtLyt_styleRecruitImage;
				if(self_.isEmpty(image_)) { return null }
				return self_.getStylesVal(image_.url)
			},
			$_rctSchdlShtLyt_styleRecruitBigImage() {
				const self_ = this;
				const recruit_ = self_.$_rctSchdlShtLyt_recruitRecruitment;
				if(self_.isEmpty(recruit_)) { return null }
				return recruit_.bigImage
			},
			$_rctSchdlShtLyt_styleRecruitBigImageUrl() {
				const self_ = this;
				const bigImage_ = self_.$_rctSchdlShtLyt_styleRecruitBigImage
				if(self_.isEmpty(bigImage_)) { return null }
				return self_.getStylesVal(bigImage_.url)
			}
		},
		methods: {
			$_rctSchdlShtLyt_openSchedule(scheduleId) {
				const self_ = this;
				const router_ = self_.$router;

				const to_ = {
					name: 'recruitSchedule',
					params: {
						recruitmentId: self_.$_rctSchdlShtLyt_paramsRecruitmentId,
						scheduleId: scheduleId
					}
				}

				router_.push(to_)
			},
			$_rctSchdlShtLyt_getFirst() {
				const self_ = this;

				const schedules_ = self_.$_rctSchdlShtLyt_recruitSchedules;
				const sorted_ = self_.sortObject(schedules_, 'order')
				const keys_ = Object.keys(sorted_)

				return keys_[0]
			},
			$_rctSchdlShtLyt_updateRecruitState(recruit) {
				const self_ = this;

				const recruitment_ = self_.$_rctSchdlShtLyt_paramsRecruitmentId;

				Promise.resolve().then(() => {
					return self_.setUserRecruit(recruitment_, recruit)
				}).then(() => {
					self_.initializeUser('recruit')
				}).catch(error => {
					let error_
					if(self_.isFalse(error)) {
						error_ = 'Error: created() -> promise';
					} else { error_ = error }
/* error */			self_.logError('Error', '$_rctSchdlShtLyt_updateRecruitState(recruit)', error_)
/* debug */			self_.logDebug('debug', 'recruit', recruit)
				})
			},
			$_rctSchdlShtLyt_checkAppliedDate(scheduleVals) {
				const self_ = this;

				const calendar_ = self_.getPageState('calendar')
				const date_ = calendar_.date;

				if(self_.isEmpty(date_)) { return true }

				const start_ = self_.formatTimestamp(scheduleVals.startDate, 'YYYY-MM-DD')
				const end_ = self_.formatTimestamp(scheduleVals.endDate, 'YYYY-MM-DD')

				return start_ <= date_ && end_ >= date_
			},
			$_rctSchdlShtLyt_checkScheduleIsApplied(scheduleId) {
				const self_ = this;
				
				const applied_ = self_.$_rctSchdlShtLyt_stateUserRecruitAppliedSchedule;

				if(self_.isEmpty(applied_)) { return false }

				if(self_.isFalse(applied_[scheduleId])) { return false }
				return applied_[scheduleId]
			}
		}
	}
</script>

<style scoped>
</style>